<template>
  <div class="password-column">
    <template v-if="!row.password">
      <BaseElButton
        type="text"
        class="underline text-danger"
        @click="$emit('regenerate')"
      >
        重建密碼
      </BaseElButton>
    </template>
    <template v-else>
      <div class="flex flex-col gap-1">
        <span v-if="hasNumber">{{ row.password || '-' }}</span>
        <BaseElButton
          v-if="hasQRCode"
          type="text"
          class="underline"
          @click="$emit('viewQRCode')"
        >
          檢視 QR Code
        </BaseElButton>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'PasswordColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  emits: ['viewQRCode', 'regenerate'],
  setup (props) {
    const methods = computed(() => {
      return (props.row.MiezoAccessControls || []).map(ac => ac.unlockMethod)
    })

    const hasNumber = computed(() => methods.value.includes('number'))
    const hasQRCode = computed(() => methods.value.includes('qrCode'))

    return {
      hasNumber,
      hasQRCode,
    }
  },
})
</script>

<style lang="postcss" scoped>
.password-column {
  @apply flex items-center justify-center;
}
</style>
